import {
  GetReadyAnnouncement,
  GetReadyAnnouncementCreateDto,
  GetReadyAnnouncementUpdateDto,
} from "@/lib/types";
import { createQueryHooks } from "../base";
import { getReadyAnnouncementsService } from "@/lib/api/getready/announcements";

// Generate standard hooks
const standardHooks = createQueryHooks<
  GetReadyAnnouncement,
  GetReadyAnnouncementCreateDto,
  GetReadyAnnouncementUpdateDto
>("getReadysAnnouncements", getReadyAnnouncementsService);

// Export standard hooks
export const {
  keys: getReadyAnnouncementsKeys,
  useEntities: useGetReadyAnnouncements,
  useEntity: useGetReadyAnnouncement,
  useCreateEntity: useCreateGetReadyAnnouncement,
  useUpdateEntity: useUpdateGetReadyAnnouncement,
  useDeleteEntity: useDeleteGetReadyAnnouncement,
} = standardHooks;
